// extracted by mini-css-extract-plugin
export default {"recipe":"recipe_recipe__K9ewk","img":"recipe_img__xkO4H","tags":"recipe_tags__+ZUvq","title":"recipe_title__Rfs2p","heart":"recipe_heart__e105Z"};